const Profuction = true; // Set to true for production environment
//export const api = Profuction ? 'https://healthinfo.ehiswgcpi.org/api/v1' : 'http://localhost:8800/api/v1'
export const api = Profuction ? 'https://healthinfo.cpinfomx.org/api/v1' : 'http://localhost:8800/api/v1'

